"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montecosaro": {
    "0a992cce": [{
      "hkey": "6cefc26a",
      "slug": "montecosaro-scalo",
      "name": "Montecosaro Scalo",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-stazione": [{
      "hkey": "6cefc26a",
      "slug": "montecosaro-scalo",
      "name": "Montecosaro Scalo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6f1b7685": [{
      "hkey": "82f0253a",
      "slug": "casette",
      "name": "Casette",
      "primary": true,
      "skipSearch": false
    }],
    "casette-molino": [{
      "hkey": "82f0253a",
      "slug": "casette",
      "name": "Casette",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;